import { apiClient } from '@/shared/api'

import { TBankCode } from '../model/schema'

export const getBankCodes = async () => {
  const response = await apiClient.get<TBankCode[]>({
    endpoint: `/accounts/bank-codes`,
  })

  return response
}
